export default "__VITE_ASSET__C$5UVH0o__"